import { render } from "./OurProductsComp.vue?vue&type=template&id=7644171f&scoped=true"
import script from "./OurProductsComp.vue?vue&type=script&lang=js"
export * from "./OurProductsComp.vue?vue&type=script&lang=js"

import "./OurProductsComp.vue?vue&type=style&index=0&id=7644171f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7644171f"]])

export default __exports__